import { deployDetailParams, deployParams, normalizeCollectionResponse, normalizeRecordResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const deployQuery = async ({ req, params }) => {
	const formattedParams = { ...deployDetailParams, context: ['cache', 'ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/deploys/${params.deployId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const deploysQuery = async ({ req, params, query }) => {
	const formattedParams = { ...deployParams, ...query, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/deploys`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
